import { memo } from 'react';

import { COLOR_SILVER_LINING } from 'Lib/colorsAndFills';

import SvgIcon from './lib/SvgIcon';

type Props = React.ComponentProps<typeof SvgIcon> & {
  fill?: string;
};

const Star = (props: Props) => {
  const { fill = COLOR_SILVER_LINING, ...restProps } = props;

  return (
    <SvgIcon {...restProps}>
      <path
        d="M11.999 2C11.999 7.001 17 12 22 12c-5.001 0-10 5.382-10 10 0-4.618-5.027-10-10-10 4.974 0 9.999-4.999 9.999-10z"
        fill={fill}
      />
    </SvgIcon>
  );
};

Star.normalized = true;

export default memo(Star);
